import { Injectable } from "@angular/core";
import { languages } from '../../../../config/languages';

/**
 * A service that gives language data.
 */
@Injectable({providedIn: 'root'})
export class LanguagesService {

  /**
   * Returns an array of all the languages that are supported by the GLN.
   * @returns {Language[]} - an array of all the languages that are supported by the GLNs.
   */
  getLanguagesList(): Language[] {
    return languages;
  }

  /**
   * Gets the label for the given value in the given language.
   * @param {string} value - the value to get the label for.
   * @param {AvailableLanguages} targetLanguage - the language to get the label for.
   * @returns {string | null} the label for the given value in the given language.
   */
  getLabel(value: string, targetLanguage: AvailableLanguages) {
    const matchingLanguage = languages.filter(lang => lang.value === value)[0];
    if (matchingLanguage && matchingLanguage[targetLanguage]) {
      return matchingLanguage[targetLanguage]
    }
    return null;
  }
}

/**
 * A language object that contains the value of the label, the French and English versions of the label.
 * @property {string} value - The label of the language.
 * @property {string} fr - The French version of the language.
 * @property {string} en - The English version of the language.
 */
export interface Language {
  value: string,
  fr: string,
  en: string
}

/**
 * A list of the languages that the app can be translated into.
 */
export type AvailableLanguages= 'fr' | 'en';
